import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path, Rect } from "react-native-svg";

export const IconGiftBox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGiftBox"><Path d="M2 4H11V9H2V4Z" fill="currentColor"/><Path d="M3 11H11V20H3V11Z" fill="currentColor"/><Rect x="13" y="4" width="9" height="5" fill="currentColor"/><Rect x="13" y="11" width="8" height="9" fill="currentColor"/></CentralIconBase>;
});

export default IconGiftBox;
